module.exports = __webpack_public_path__ + "static/media/asset.7f346739.png";